export default __webpack_public_path__ + "static/media/syllos_2.6dd8f990.png";